import React, { memo, useState } from 'react';
import './css/style.scss';
import { CgArrowLongRight } from '../../../../components/icons';

import { IoLayersOutline, AiFillClockCircle, CertificateIcon } from '../../../../components/icons';

import SponsorLogoCard from '../../../SponsorLogoCard';
import useRedirect from '../../../customHooks/useRedirect';
import { specialityPopOver } from '../../../../common/common';
import ShareCard from '../../../ShareCard';
import { colorDecider, parseDuration } from '../../../../pages/grTraining/utils/utilities';
import LazyImage from '../../../CustomLibraries/LazyImage';
import { certified_courses_static_image } from '../../../../common/assets.common';
import InView from 'react-intersection-observer';
import { useTrackUserActivity } from '../../../customHooks/useTrackUserActivity';

const GrCardV2 = ({ data, hideImage, gtmTagVariable = '' }) => {
  const [isHoverd, setIsHoverd] = useState(false);
  const {
    image,
    title,
    duration,
    is_certificate,
    is_completed,
    id,
    specialities,
    module_Count,
    sponsor_logo,
    deeplink,
    specialities_ids_and_names
  } = data;
  const { redirectTo } = useRedirect();
  const click = () => redirectTo(is_completed > 0 ? 'TrainingContent' : 'TrainingCover', id, title);
  const { userActivityTracker } = useTrackUserActivity();
  return (
    <InView
      as="div"
      onChange={(inView) => {
        userActivityTracker(inView, { type: 'training', ...data }, 'card');
      }}
      className="w-100 float-start grCardV2Box shadow rounded-3 text-start bg-white overflow-hidden position-relative p-3 p-lg-4"
    >
      <span
        className="graph-1 position-absolute start-0 bottom-0"
        style={{ backgroundColor: '#4b63ab' }}
      ></span>
      <span
        className="graph-2 position-absolute start-0 bottom-0"
        style={{ backgroundColor: '#4b63ab' }}
      ></span>

      {!hideImage && (
        <div
          className="grCardV2BoxPic cursorPointer rounded-3 position-relative overflow-hidden z-1 mb-3 mb-lg-4"
          onClick={click}
        >
          <LazyImage
            src={image}
            className={`object-fit-cover w-100 h-100 float-start gtm_cl_grCardV2`}
            fallback_image={certified_courses_static_image}
          />

          {is_certificate && (
            <div className="rounded-3 overflow-hidden text-black fs-4 grCardV2Certificate position-absolute z-1 bg-white shadow p-3 d-flex justify-content-between align-items-center grCardV2Certificate">
              <span
                className={`grCardV2CertificateIcon position-absolute top-0 start-0 h-100 pe-2 d-flex justify-content-center align-items-center gtm_cl_grCardV2`}
                // id={`grCardV2_certificateCompetion_section_${id}`}
                style={{ backgroundColor: '#4b63ab' }}
              >
                <CertificateIcon gtmTagVariable="gtm_cl_grCardV2" customClass="fs-1 text-white" />
              </span>
              Certificate of completion
            </div>
          )}
        </div>
      )}

      <div className="crdV2topPart d-flex align-items-center justify-content-between mb-3">
        <div
          className="text-black crdV2Speclty gtm_cl_grCardV2_speeciality d-flex gap-2 align-items-center cursorPointer"
          onClick={() => {
            if (specialities_ids_and_names?.length > 0) {
              let { id, name } = specialities_ids_and_names[0];
              redirectTo('Speciality', id, name);
            }
          }}
        >
          {/* {specialities?.split(',')[0]} */}
          {specialities_ids_and_names &&
            specialities_ids_and_names.length > 0 &&
            specialities_ids_and_names[0].name}
          {specialityPopOver(
            specialities_ids_and_names && specialities_ids_and_names.length > 0
              ? specialities_ids_and_names.map((_i) => _i.name).join(',')
              : ''
          )}
        </div>
        <a href="javascript:void(0)" className="cardV2DotsMenu text-black">
          <ShareCard data={{ title, url: deeplink }} gtmTagVariable="gtm_cl_grCardV2_share" />
        </a>
      </div>
      <div className="d-flex text-start cardV2Topic" onClick={click}>
        <h2 className={`text-black fs-16 fw-medium line-clamp-2 gtm_cl_grCardV2`}>{title}</h2>
      </div>

      <ul className="cardV2Statistics mt-4 mb-0 ps-0 d-flex gap-2 flex-wrap">
        <li className="me-3 mb-4 d-flex align-items-center gap-2">
          <IoLayersOutline customClass="fs-3 text-dark gtm_cl_grCardV2" /> {module_Count} Modules
        </li>
        <li className="me-3 mb-4 d-flex align-items-center gap-2">
          <AiFillClockCircle customClass="fs-3 text-dark gtm_cl_grCardV2" />{' '}
          {parseDuration(duration).duration} {parseDuration(duration).unit}
        </li>
        <li className="d-inline-block mb-4">
          <div
            className="circleProgress position-relative overflow-hidden rounded-circle d-inline-block me-2 align-middle gtm_cl_grCardV2"
            style={{ backgroundColor: colorDecider(is_completed) }}
          >
            <div
              className="circleProgressIn position-absolute start-50 w-100 h-100 bg-white bg-opacity-75"
              style={{
                top: `-${is_completed > 100 ? 100 : is_completed > 0 ? Math.round(is_completed) : 0 ?? 0
                  }%`
              }}
            ></div>
            <div
              className="circleProgressIn2 position-absolute start-50 w-100 h-100 bg-white bg-opacity-25 mt-1"
              style={{
                top: `-${is_completed > 100 ? 100 : is_completed > 0 ? Math.round(is_completed) : 0 ?? 0
                  }%`
              }}
            ></div>
          </div>
          {is_completed > 100 ? 100 : is_completed > 0 ? Math.round(is_completed) : 0}% Completed
        </li>
      </ul>
      <div className="cardV2Ftr d-flex align-items-center justify-content-between mt-3">
        <SponsorLogoCard sponsor_logo={sponsor_logo} />

        <div
          className="cardV2FtrBtn fs-4 fw-medium rippleEffect rounded d-inline-block overflow-hidden py-3 px-4 cursorPointer gtm_cl_grCardV2"
          onClick={click}
          onMouseEnter={() => {
            setIsHoverd(true);
          }}
          onMouseLeave={() => {
            setIsHoverd(false);
          }}
          style={{
            border: `${isHoverd
                ? '1px solid transparent'
                : `1px solid ${data?.color ? data?.color : '#22a5f8'}`
              }`,
            // color: `${isHoverd && activeHover ? '#fff' : cardData?.color ?? '#22a5f8'}`,
            backgroundColor: `${isHoverd ? (data?.color ? data?.color : '#22a5f8') : 'transparent'}`
          }}
        >
          {/* <div
            className="cardV2BtnHover position-absolute top-50 start-50 translate-middle gtm_cl_grCardV2"
            style={{ backgroundColor: '#22a5f8' }}
          ></div>
          <div
            className="cardV2BtnBorder rounded position-absolute start-0 top-50 translate-middle-y gtm_cl_grCardV2"
            style={{ borderColor: '#22a5f8' }}
          ></div> */}
          <span
            className={`position-relative z-1 gtm_cl_grCardV2 d-flex gap-2 align-items-center`}
            style={{
              color: `${isHoverd ? '#fff' : data?.color && data?.color !== '0' ? data?.color : '#22a5f8'
                }`
            }}
          >
            View Details <CgArrowLongRight customClass="fs-4" gtmTagVariable="gtm_cl_grCardV2" />
          </span>
        </div>
      </div>
    </InView>
  );
};

export default memo(GrCardV2);
